import { IToolCheckItemTemplateListResponseVM } from '../../models/response/IToolCheckItemTemplateResponse';

export const getToolCheckItemTemplateListInitialState: IToolCheckItemTemplateListResponseVM = {
  ToolCheckitemTemplateList: [],
  PagingDetails: {
    CurrentPage: 1,
    PageSize: 100,
    TotalPages: 0,
    TotalRecords: 0,
  },
};

export default getToolCheckItemTemplateListInitialState;
